module.exports = __webpack_public_path__ + "static/media/M.c018de05.jpg";